import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getRetiros } from "../api";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import { motion, AnimatePresence } from "framer-motion";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Retiros = () => {
  const [retiros, setRetiros] = useState([]);
  const [loadingRetiros, setLoadingRetiros] = useState(true);
  const showSplash = useDynamicSplash(loadingRetiros);
  const navigate = useNavigate();
  const id_perfil = localStorage.getItem("id_perfil");

  // Inyectar /perfil como historial anterior
  useEffect(() => {
    window.history.replaceState({}, "", "/perfil");
    window.history.pushState({}, "", "/retiros");
  }, []);

  useEffect(() => {
    let mounted = true;

    const cargarRetiros = async () => {
      setLoadingRetiros(true);
      document.body.style.overflow = "hidden";

      try {
        const data = await getRetiros(id_perfil);
        if (!mounted) return;
        setRetiros(data.retiros || []);
      } finally {
        if (mounted) {
          setLoadingRetiros(false);
          document.body.style.overflow = "auto";
        }
      }
    };

    if (id_perfil) {
      cargarRetiros();
    }
    return () => {
      mounted = false;
      document.body.style.overflow = "auto";
    };
  }, [id_perfil]);

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!showSplash && (
      <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
      <div className="connections-container">
        <div className="back-container">
          <button className="back-btn" onClick={() => navigate("/perfil")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
              <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292" />
            </svg>
          </button>
        </div>
        <h2 className="connections-title">Historial de retiros</h2>
      </div>

      <div className="feature-list">
        {retiros.length > 0 ? (
          retiros.map((retiro, i) => (
            <div className="feature-item" key={retiro.id_retiro}>
              <div className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" color="currentColor">
                    <path d="m18.935 13.945l-.67-3.648c-.29-1.576-.435-2.364-1.008-2.83S15.86 7 14.213 7H9.787c-1.647 0-2.47 0-3.044.467c-.573.466-.718 1.254-1.008 2.83l-.67 3.648c-.6 3.271-.901 4.907.024 5.98C6.014 21 7.724 21 11.142 21h1.716c3.418 0 5.128 0 6.053-1.074s.625-2.71.024-5.98" />
                    <path d="M12 10.5V17m-2.5-2l2.5 2.5l2.5-2.5m6.5-4a1.5 1.5 0 0 0 .414-.305C22 10.089 22 9.11 22 7.152s0-2.936-.586-3.544S19.886 3 18 3H6c-1.886 0-2.828 0-3.414.608S2 5.195 2 7.152s0 2.936.586 3.543q.18.188.414.305" />
                </g>
            </svg>
              </div>
              <div className="feature-text">
                <h3 style={{ marginBottom: 4 }}>Q{parseFloat(retiro.monto).toFixed(2)}</h3>
                <p style={{ fontSize: 13, color: "#888", marginBottom: 0 }}>
                  {new Date(retiro.fecha).toLocaleDateString("es-GT", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit"
                  })}
                </p>
                <p style={{ fontSize: 13, marginBottom: 0 }}>
                    <b>{retiro.banco_nombre || "Desconocido"}</b> ({retiro.no_cuenta})
                </p>
                <span className={`badge ${retiro.estado === 1 ? "badge-v" : "badge-w"}`}>
                  {retiro.estado === 1 ? "Completado" : "Pendiente"}
                </span>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data-wrapper" style={{height:300, marginTop:95}}>
            <div className="no-data">
              <img src="/assets/images/empty.svg" alt="Sin referidos" />
              <p>
                Aún no tienes retiros registrados.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
    </motion.div>
    )}
    </>
  );
};

export default Retiros;
